import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import { StatsProvider } from "./context/StatsContext";
import { CartProvider } from "./context/CartContext";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./Pages/Home/Home";
import LoginPage from "./Pages/LoginPage/LoginPage";
import Dashboard from "./Pages/Dashboard/Dashboard";

// E-commerce Pages
import Shop from "./Pages/Shop/Shop";
import ProductDetail from "./Pages/ProductDetail/ProductDetail";
import Cart from "./Pages/Cart/Cart";
import Checkout from "./Pages/Checkout/Checkout";

import Header from "./Pages/Home/Componenets/Header/Header";
import Footer from "./Pages/Home/Componenets/Footer/Footer";
import Toast from './components/Toast/Toast';
import { useCart } from './context/CartContext';

function AppContent() {
  const location = useLocation();
  const { toast, setToast } = useCart();

  const isNoLayoutPage =
    location.pathname.startsWith("/dashboard") ||
    location.pathname === "/login";

  return (
    <ThemeProvider>
    <div className="App">
      {!isNoLayoutPage && <Header />}
      
      <Toast 
        {...toast} 
        onClose={() => setToast({ ...toast, show: false })} 
      />
      
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          
          {/* E-commerce */}
          <Route path="/shop" element={<Shop />} />
          <Route path="/product/:slug" element={<ProductDetail />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/checkout" element={<Checkout />} />
          
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected dashboard routes */}
          <Route path="/dashboard/*" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      {!isNoLayoutPage && <Footer />}
    </div>
    </ThemeProvider>
  );
}

export default function AppWrapper() {
  return (
    <AuthProvider>
      <StatsProvider>
        <CartProvider>
          <Router>
            <AppContent />
          </Router>
        </CartProvider>
      </StatsProvider>
    </AuthProvider>
  );
}